import React from 'react';
import styles from './ContentSkeleton.module.scss';

const ContentSkeleton: React.FC = () => (
	<div className={styles.wrapper} aria-hidden='true'>
		<div className={`${styles.bar} ${styles.w40}`} />
		<div className={styles.block} />
		<div className={`${styles.bar} ${styles.w90}`} />
		<div className={`${styles.bar} ${styles.w70}`} />
		<div className={styles.block} />
	</div>
);

export default ContentSkeleton;
